import React, { useMemo, useState } from "react";
import ModalDialogFrame from "../../../components/ModalDialogFrame";
import PlanSelect from "./screens/PlanSelect";
import { createPlatformStackNavigator } from "../../../navigations/createPlatformStackNavigator";
import { Buildable } from "ts-essentials";
import { Cct, LppPlan } from "../../../__generated__/graphql";
import { LPPEditorStackParamList, LPPEditorContextType } from "./types";
import { LPPEditorContext } from "./context";

type LPPEditorNavigatorProps = {
    lppPlan?: Buildable<LppPlan>;
    availablePlans: LppPlan[];
    cct?: Cct;
    useLse: boolean;
    onSave?: (plan?: LppPlan) => void | Promise<void>;
};

const Stack = createPlatformStackNavigator<LPPEditorStackParamList>();

/**
 * LPPEditorNavigator is a stack navigator for the LPP editor it is used through the use-lpp-editor.ts hook
 * You should never call this component navigation directly, it is used in the LPPEditorNavScreen
 * @constructor
 */
const LPPEditorNavigator: React.FC<LPPEditorNavigatorProps> = ({
    lppPlan,
    availablePlans,
    cct,
    useLse,
    onSave,
}) => {
    const [selectedPlan, setSelectedPlan] = useState<LppPlan | undefined>(
        (lppPlan as LppPlan) || undefined,
    );

    const contextValue = useMemo<LPPEditorContextType>(
        () => ({
            selectedPlan,
            setSelectedPlan,
            cct,
            useLse,
            availablePlans,
            onSave,
        }),
        [selectedPlan, onSave, cct, availablePlans, useLse],
    );

    return (
        <LPPEditorContext.Provider value={contextValue}>
            <ModalDialogFrame>
                <Stack.Navigator
                    initialRouteName="LPPPlanSelect"
                    screenOptions={{
                        headerShown: false,
                        gestureEnabled: false,
                    }}
                    // Native drives the slide via `animation`; web keeps the JS-stack card options.
                    nativeScreenOptions={{ animation: "slide_from_bottom" }}
                    webScreenOptions={{
                        detachPreviousScreen: false,
                        cardStyle: { overflow: "visible" },
                    }}
                >
                    <Stack.Screen name="LPPPlanSelect" component={PlanSelect} />
                </Stack.Navigator>
            </ModalDialogFrame>
        </LPPEditorContext.Provider>
    );
};

export default LPPEditorNavigator;
